import { render, staticRenderFns } from "./TipstersCard.vue?vue&type=template&id=f17dd024&"
import script from "./TipstersCard.vue?vue&type=script&lang=js&"
export * from "./TipstersCard.vue?vue&type=script&lang=js&"
import style0 from "./TipstersCard.vue?vue&type=style&index=0&id=f17dd024&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports